import useGetProductTagsData from './useGetProductTagsData'

export default useGetProductTagsData
